// extracted by mini-css-extract-plugin
export default {"headerWrapper":"styles_headerWrapper__tXWL6","root":"styles_root__CRtz-","contentParent":"styles_contentParent__1Za4Y","children":"styles_children__vdfCJ"};